import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/styles';
import { Redirect } from 'react-router-dom';
import firebase from './firebase';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                EasyOrder
      </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
            <Link color="inherit" href="https://material-ui.com/">
            </Link>
        </Typography>
    );
}

const styles = {
    '@global': {
        body: {
            backgroundColor: 'white',
        },
    },
    paper: {
        backgroundColor: 'white',
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    Grid: {
        alignItems: 'center',
    },
    avatar: {
        margin: 1,
        backgroundColor: 'white',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: 1,
    },
    submit: {
        margin: '5px 0px 15px',
        backgroundColor: '#1BE9B6',
        color: 'white',
        height: '50px',
        '&:hover': {
            background: "rgb(19, 179, 139)"
        }
    },
    submit2: {
        margin: '5px 0px 5px',
        backgroundColor: '#3b5998',
        color: 'white',
        height: '50px',
        '&:hover': {
            background: "#2f55a4",
        },
    },
    signin: {
        color: '#aaaaaa'
    }

};

const useStyles1 = makeStyles(theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },

}));

class LoginPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: "",
            password: "",
            phone: "",
            name: "",
            errorTextName: "",
            errorTextEmail: "",
            errorTextPassword: "",
            errorTextPhone: "",
            auth: "",
            validation: "",
            message: "",
            error: true
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);

    }

    handleRefresh = () => {
        this.props.history.push("/");
    }

    isAuthenticated = () => {
        const token = localStorage.getItem("token");
        return token && token.length > 10;
    }

    handleChange = ({ target }) => {
        const { name, value } = target;
        this.setState({
            [name]: value,
            validation: "",
            open: false
        });

    }

    handleClose = () => {
        this.setState({ open: false })
    }

    registerPasswordUser = (email, name, password, phone) => {
        var user = null;

        firebase.auth().createUserWithEmailAndPassword(email, password)
            .then(function () {
                user = firebase.auth().currentUser;
                user.sendEmailVerification();
                console.log("UID RESPONSE:"+user.uid);
            })
            .then(function () {
                const data = {name: name, email: email, phone: phone, uid: user.uid, source:"email"};                       
                fetch("https://us-central1-ubergreen-c4174.cloudfunctions.net/register", {
                    body: JSON.stringify(data),
                    method: 'POST',
                    crossDomain: true,
                    headers:{
                        "Content-Type": "application/json"
                    }               
                })
                .then(async res => {
                
                const value = await res.json();
                    console.log(value);
                })
            })
            .catch(function (error) {
                console.log(error.message, 7000);
            });

        this.setState({
            //validation: error.message,
            open: true,
            message: 'Se ha enviado un email de verficación al correo: ' + email + '.'
        });
        console.log('Se ha enviado un email de verficación al correo: ' + email + '.');

        this.setState({ email: "", password: "", name: "", phone: "" })
    }

    submitForm = (event) => {
        event.preventDefault();
        const { email, password, name, phone } = this.state;
        if (this.state.name != "") {
            this.setState({ errorTextName: '', error: false })
        } else {
            this.setState({ errorTextName: 'Debe indicar el Nombre', error: true })
        }

        if (this.state.phone != "") {
            this.setState({ errorTextPhone: '', error: false })
        } else {
            this.setState({ errorTextPhone: 'Debe indicar el Telefono', error: true })
        }

        if (this.state.email != "") {
            this.setState({ errorTextEmail: '', error: false })
        } else {
            this.setState({ errorTextEmail: 'Debe indicar el Email', error: true })
        }

        if (this.state.password != "") {
            this.setState({ errorTextPassword: '', error: false })
        } else {
            this.setState({ errorTextPassword: 'Debe indicar el Password', error: true })

        }

        const app = this;

        if (email != "" && password != "" && name != "" && phone != "") {
            this.registerPasswordUser(this.state.email, this.state.name, this.state.password, this.state.phone);
        }

        //alert("con error");
        /*
                firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).catch(function (error) {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    app.setState({
                        validation: error.message,
                        open: true,
                        message: error.message
                    });
                });
        
        
                firebase.auth().onAuthStateChanged(function (user) {
                    if (user) {
                        console.log(user);
                        firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
                            localStorage.setItem('token', idToken);
                            localStorage.setItem('userId', user.uid);
                            app.setState({});
                        }).catch(function (error) {
                            // Handle error
                        });
                    } else {
                        // No user is signed in.
                    }
        
                });
        */
    }

    render() {
        const classes = this.useStyles1;
        if (!localStorage.getItem("token")) {
            firebase.auth().signOut();
        }
        const isAlreadyAuthenticated = this.isAuthenticated();
        return (<div style={{ marginTop: "80px" }}>
            {isAlreadyAuthenticated ? <Redirect to={{ pathname: '/recicla' }} /> : (
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Snackbar
                        style={{ backgroundColor: "#1BE9B6", color: 'coral' }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        open={this.state.open}
                        autoHideDuration={6000}
                        onClose={this.handleClose}
                        variant="success"
                        action={[
                            <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleClose}>
                                <CloseIcon />
                            </IconButton>,
                        ]}
                    >
                        <SnackbarContent style={{
                            backgroundColor: '#1BE9B6',
                        }}
                            message={<span id="client-snackbar">{this.state.message}</span>}
                        />
                    </Snackbar>

                    <div className={this.props.classes.paper}>
                        <form className={this.props.classes.form} noValidate onSubmit={this.submitForm.bind(this)}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="name"
                                label="Nombre"
                                name="name"
                                autoComplete="name"
                                value={this.state.name}
                                autoFocus
                                onChange={this.handleChange}
                                error={this.state.errorTextName.length === 0 ? false : true}
                                helperText={this.state.errorTextName}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="phone"
                                label="Telefono"
                                name="phone"
                                autoComplete="telefono"
                                value={this.state.phone}
                                onChange={this.handleChange}
                                error={this.state.errorTextPhone.length === 0 ? false : true}
                                helperText={this.state.errorTextPhone}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                value={this.state.email}
                                onChange={this.handleChange}
                                error={this.state.errorTextEmail.length === 0 ? false : true}
                                helperText={this.state.errorTextEmail}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Contraseña"
                                type="password"
                                id="password"
                                value={this.state.password}
                                autoComplete="current-password"
                                onChange={this.handleChange}
                                error={this.state.errorTextPassword.length === 0 ? false : true}
                                helperText={this.state.errorTextPassword}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant={this.props.classes.submit2}
                                color="primary"
                                className={this.props.classes.submit2}
                            >
                                Ingresar con Facebook
                            </Button>
                            <Button
                                type="submit"
                                fullWidth
                                color="primary"
                                className={this.props.classes.submit}
                            >
                                Registrar
                    </Button>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <Link href="forgot-pass" variant="body2" align="center">
                                        Olvidaste tu Contraseña?
                            </Link>
                                </Grid>
                                <Grid item>
                                    <Link href="register" variant="body2">
                                        {"No tienes una cuenta UberGreen? Registrate"}
                                    </Link>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                    <Box mt={8}>
                        <Copyright />
                    </Box>
                </Container>
            )

            }</div>);

    }
}

export default withStyles(styles)(LoginPage);